import { render, staticRenderFns } from "./FormAverage.vue?vue&type=template&id=b4ef60a8&"
import script from "./FormAverage.vue?vue&type=script&lang=js&"
export * from "./FormAverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports